import { render } from "./RecoverPassword.vue?vue&type=template&id=1f88f0a9"
import script from "./RecoverPassword.vue?vue&type=script&lang=js"
export * from "./RecoverPassword.vue?vue&type=script&lang=js"

import exportComponent from "/home/admin/armada-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__